<template>
    <div>
        <card-header title="Organization Settings" icon="fa-building-user" />

        <card-toolbar v-if="currentUser.isAdmin || currentUser.isSuper">
            <button @click="$openCard('new-org-user', {}, card)"><i class="far fa-plus"></i>New User</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <subheader-list-item icon="fa-id-card-clip" title="Information" />

                <container-list-item padded>
                    <div class="columns">
                        <div class="column">
                            <b-field label="Title" label-position="inside">
                                <b-input v-model="org.title" required></b-input>
                            </b-field>
                        </div>
                    </div>
                </container-list-item>

                <subheader-list-item icon="fa-money-check-dollar-pen" title="Revenue Payout" />

                <container-list-item padded v-if="!org.is_stripe_active">
                    <b-button @click="onboard()"><i class="fas fa-arrow-up-right-from-square mr-3"></i>Connect with Stripe</b-button>
                </container-list-item>

                <navigation-list-item
                    v-else
                    icon="fa-money-check-dollar-pen"
                    title="Manage Payout"
                    @click="$openCard('org-payout', {}, card)"
                    :active="(child && child.definition.component === 'org-payout')"
                />

                <subheader-list-item icon="fa-users" title="Users" />

                <portal-user-tile
                    :user="u"
                    :card="card"
                    v-for="u in org.users"
                    @click="$openCard('edit-org-user', {userId: u.id}, card)"
                    :active="(child && child.definition.component === 'edit-org-user' && u.id === parseInt(child.props.userId))"
                ></portal-user-tile>

            </card-list>
        </card-body>

        <card-footer class="pt-3 pb-3 has-text-right">
            <b-button
                type="is-primary"
                size="is-small"
                @click="submit"
                :disabled="!org.title"
            ><i class="fas fa-check mr-2"></i>Update
            </b-button>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/components/common/CardHeader";
    import CardBody from "@/components/common/CardBody";
    import {client as http} from '@/http_client';
    import CardFooter from "@/components/common/CardFooter";
    import {mapGetters} from "vuex";
    import CardList from "../../TIER/components/CardList.vue";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem.vue";
    import ContainerListItem from "../../TIER/components/ContainerListItem.vue";
    import CardToolbar from "../../TIER/components/CardToolbar.vue";
    import PortalUserTile from "../../components/tiles/PortalUserTile.vue";
    import NavigationListItem from "../../TIER/components/NavigationListItem.vue";

    export default {
        components: {NavigationListItem, PortalUserTile, CardToolbar, ContainerListItem, SubheaderListItem, CardList, CardFooter, CardBody, CardHeader},
        props: ['card', 'props', 'child'],
        data() {
            return {
                org: {}
            }
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        methods: {
            loadOrg: function () {
                this.$emit('loading', true);
                http.get('organizations/self', {force: true}).then(response => {
                    this.org = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            onboard: function () {
                this.$emit('loading', true);
                http.get('stripe/onboard').then(response => {
                    window.open(response.data.link);
                    this.$closeCard(this.card);
                });
            },
            submit: function () {
                this.$emit('loading', true);
                http.put('organizations/' + this.org.id, {title: this.org.title, id: this.org.id}).then(response => {
                    this.$closeCard(this.card);
                });
            },
            reload: function () {
                this.loadOrg();
            }
        },
        mounted: function () {
            this.loadOrg();
        }
    }
</script>
